export enum ProductTableRowFormat {
  Boolean = 'boolean',
  Video = 'video',
  Rating = 'rating',
}
